import { render, staticRenderFns } from "./btn-up.vue?vue&type=template&id=f117666c&scoped=true&"
import script from "./btn-up.vue?vue&type=script&lang=js&"
export * from "./btn-up.vue?vue&type=script&lang=js&"
import style0 from "./btn-up.vue?vue&type=style&index=0&id=f117666c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f117666c",
  null
  
)

export default component.exports